const PhoneExtensions = [
    { code: "+45", country: "DK" }
];

export default PhoneExtensions;